import request from '@/utils/request'

// 发起问诊
export function startConsult(data) {
  return request({
    url: '/health-doctor-assistant/HelpPatient/startConsult',
    method: 'post',
    data
  })
}
